import { StyleSheet, Platform } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: theme => ({
    height: '100%',
    backgroundColor: theme.colors.quickActionBackground,
    marginBottom: Platform.OS === 'android' ? 23 : 12,
  }),
  iconStyle: {
    alignSelf: 'center',
    marginTop: 21,
  },
  title: theme => ({
    fontSize: 18,
    lineHeight: 21,
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
    alignSelf: 'center',
    marginTop: 8,
  }),
  description: theme => ({
    fontSize: 16,
    lineHeight: 21,
    color: theme.colors.textColorThree,
    marginTop: 16,
    marginBottom: 46,
    alignSelf: 'center',
    textAlign: 'center',
  }),
  btnSuccess: {
    marginBottom: 20,
  },
  closeBtnStyle: {
    marginRight: -20,
    marginTop: 12.5,
  },
});
